import { useContext } from 'react';
import { Buttons, FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import CustomTransition from 'Components/CustomTransition';
import { ShareModal } from 'Components/Modal/components';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from './styles';

const ReferralBanner = (): JSX.Element | null => {
  const { t } = useTranslation(locizeNS.MGM);
  const { showModal } = useContext(ModalContext);
  const openShareModal = (): void => {
    showModal({
      comp: <ShareModal isFiling={false} />,
    });
  };
  return (
    <Styled.Container direction="column" align="center">
      <CustomTransition start>
        <FlexContainer direction="column" gap="dimension_16">
          <Styled.Content>
            <img src={`${TAXDOWN_ASSETS_DOMAIN}/mgm/coin.svg`} alt="coin" />
            <FlexContainer direction="column" gap="dimension_08">
              <Text type="paragraphs" color="dark" size="S_L_S">
                {t('ReferralBanner.title')}
              </Text>
              <Text type="paragraphs" color="dark_500" size="XS_M_S">
                {`${t('ReferralBanner.friends')}`}
              </Text>
            </FlexContainer>
          </Styled.Content>
          <FlexContainer justify="center">
            <Buttons.Classic
              mode="primary"
              label={t('ReferralBanner.button')}
              size="s"
              onClick={openShareModal}
            />
          </FlexContainer>
        </FlexContainer>
      </CustomTransition>
    </Styled.Container>
  );
};

export default ReferralBanner;
